export default __webpack_public_path__ + "static/media/manabg.9386fcbf.svg";